const TOKEN_KEY = 'token';
const USUARIO_KEY = 'usuario';
const MENSAJE_SESION_KEY = 'mensajeSesion';

export function obtenerTokenSesion() {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function obtenerUsuarioSesion() {
  try {
    return JSON.parse(sessionStorage.getItem(USUARIO_KEY) || '{}');
  } catch {
    return {};
  }
}

export function guardarSesion(token, usuario) {
  limpiarSesionAuth();

  sessionStorage.setItem(TOKEN_KEY, token);
  sessionStorage.setItem(USUARIO_KEY, JSON.stringify(usuario));
}

export function limpiarSesionAuth() {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USUARIO_KEY);
  sessionStorage.removeItem(MENSAJE_SESION_KEY);

  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USUARIO_KEY);
  localStorage.removeItem(MENSAJE_SESION_KEY);
}

export function guardarMensajeSesion(mensaje) {
  sessionStorage.setItem(
    MENSAJE_SESION_KEY,
    mensaje || 'Tu sesión expiró. Inicia sesión nuevamente.'
  );

  localStorage.removeItem(MENSAJE_SESION_KEY);
}

export function consumirMensajeSesion() {
  const mensaje =
    sessionStorage.getItem(MENSAJE_SESION_KEY) ||
    localStorage.getItem(MENSAJE_SESION_KEY);

  sessionStorage.removeItem(MENSAJE_SESION_KEY);
  localStorage.removeItem(MENSAJE_SESION_KEY);

  return mensaje;
}
